import axios from 'axios';
import * as types from '../constants/ActionTypes';

// Url's
const getCancelOrderReasonUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-cancel-order-reason-list`;
const getCancelOrderListUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-cancel-order-list`;
const getSaveCancelOrderUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaorder-cancel/create-cancel`;

// Actions

// Get Cancel Order List

const cancelOrderRequest = () => ({
    type :types.CANCEL_ORDER_REQUEST
})

const cancelOrderSuccess = (data) => ({
    type: types.CANCEL_ORDER_SUCCESS,
    data
})

const cancelOrderFailure = (error) => ({
    type: types.CANCEL_ORDER_FAILURE,
    error
})

// Post Cancel Order List

const saveCancelOrderRequest = () => ({
  type: types.SAVE_CANCEL_ORDER_REQUEST
})

const saveCancelOrderSuccess = (data) => ({
  type: types.SAVE_CANCEL_ORDER_SUCCESS,
  data
})

const saveCancelOrderFailure = (error) => ({
  type: types.SAVE_CANCEL_ORDER_FAILURE,
  error
})

// Cancel Order Reason List 

const GetCancelOrderReasonListRequest = () => ({
  type: types.CANCEL_ORDER_REASON_LIST_REQUEST
})

const GetCancelOrderReasonListSuccess = (data) => ({
  type: types.CANCEL_ORDER_REASON_LIST_SUCCESS,
  data
})

const GetCancelOrderReasonListFailure = () => ({
  type: types.CANCEL_ORDER_REASON_LIST_FAILURE
})

// API for get list of cancel order

export const getCancelOrderList = (connection_id, mobile) => {
    return dispatch => {
      dispatch(cancelOrderRequest());
      axios.get(getCancelOrderListUrl, {
        params: {
          connection_id,
          mobile_no: mobile
        },
      })
        .then(res => {
          if (res.data.ack === "Success") {
              // 
            dispatch(cancelOrderSuccess(res.data.results));
          } else if (res.data.ack === "Failure") {
            dispatch(cancelOrderFailure(res.data.status));
          } 
        })
        .catch(err => {
            throw err;
        });
    };
  };

// API for save list of cancel order

export const saveCancelOrderList = (connection_id, optoins) => {
  return dispatch => {
    dispatch(GetCancelOrderReasonListRequest())
    axios.post(getSaveCancelOrderUrl, 
      {
        token : connection_id,
        optoins
      },
      {
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          //'Content-Type': 'application/json; charset=UTF-8'
        },
    })
    .then(res => {
      if(res.data.ack === 'Success')
      {
        dispatch(saveCancelOrderSuccess(res.data))
      }
      else if(res.data.ack === 'Failure'){
        dispatch(saveCancelOrderFailure(res.data.status))
      }
    })

    .catch(err => {
      throw err;
    })
  }
}

// API for get Cancel Order Reason List

export const getCancelOrderReasonList = (connection_id, reasonType) => {
  return dispatch => {
    dispatch(cancelOrderRequest());
    axios.get(getCancelOrderReasonUrl, {
      params: {
        connection_id,
        reason_type: reasonType
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(GetCancelOrderReasonListSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(GetCancelOrderReasonListFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
      });
  };
};